import { createSelector, Dispatch } from '@reduxjs/toolkit';
import { BootstrapConfig, CmsValue } from 'core/type/BootstrapConfig.types';
import { ScreenSize, selectScreenSize } from 'store/slice/screen';
import { RecentSearchItem } from 'core/type/SuggestionResult.types';
import { selectCmsFromBootstrap, selectConfigFromBootstrap, selectFeatureBehaviorFromBootstrap } from 'store/slice/bootstrap';
import { isB } from 'core/window/bootstrapConfig';
import { ExperimentId } from 'core/type/ExperimentId';
import { getPathPrefix, getSearchPageFromCityIdAndActivityIdUrl, getSearchPageUrl } from 'core/utils/activityUrlGenerator';
import { trackElementEvent } from 'core/messaging/analytics/analytics';
import { ActivitiesSearchHistoryItemClickEventActivitiesFieldsV2 } from '@agoda/analytics-messages-definition-activities/events.split';
import { ActivitiesSearchHistoryItemClickEventActivitiesManifestV2 } from '@agoda/analytics-messages-definition-activities/manifest/events';
import { RecentSearchType, TextSearchType } from 'core/type/TextSearch.types';
import { routeTo } from 'store/slice/navigation';

interface StateProps {
    config: BootstrapConfig;
    cms: CmsValue;
    screenSize: ScreenSize;
    isActivityRedirectExperimentEnabled: boolean;
}

interface DispatchProps {
    onHistoryItemClick: (recentSearch: RecentSearchItem, index: number, config: BootstrapConfig, isActivityRedirectExperimentEnabled: boolean) => void;
}

export type RecentSearchProps = StateProps & DispatchProps;

export const mapStateToProps = createSelector(
    selectConfigFromBootstrap,
    selectCmsFromBootstrap,
    selectScreenSize,
    selectFeatureBehaviorFromBootstrap,
    (config, cms, screenSize, featureBehaviors): StateProps => {
        return {
            config,
            cms,
            screenSize,
            isActivityRedirectExperimentEnabled: featureBehaviors.EmptyStateSuggestionsRedirect,
        };
    },
);

export const mapDispatchToProps = (dispatch: Dispatch): DispatchProps => ({
    onHistoryItemClick: (recentSearch: RecentSearchItem, index: number, config: BootstrapConfig, isActivityRedirectExperimentEnabled: boolean) => {
        const isRecentSearchFix = isB(ExperimentId.ACT_4566, config.experiments);
        const url = isRecentSearchFix
            ? recentSearch.isUrlWithPrefix
                ? recentSearch.url
                : getSearchPageUrl(recentSearch, undefined, undefined, config)
            : !recentSearch.emptyStateType
              ? getSearchPageUrl(recentSearch, undefined, undefined, config)
              : recentSearch.url;

        const selectedActivitySSRUrl = getSearchPageFromCityIdAndActivityIdUrl(recentSearch.cityId, recentSearch.id);
        trackElementEvent<ActivitiesSearchHistoryItemClickEventActivitiesFieldsV2>(
            ActivitiesSearchHistoryItemClickEventActivitiesManifestV2.ids,
            {},
            {
                action_element_value: recentSearch.type === TextSearchType.Activity ? RecentSearchType.Activity : RecentSearchType.City,
                action_element_index: index + 1,
                activity_id: recentSearch.id,
                city_id: recentSearch.cityId,
                supplier_id: recentSearch.supplierId,
            },
        );
        const dispatchUrl = recentSearch.type === TextSearchType.Activity && isActivityRedirectExperimentEnabled ? selectedActivitySSRUrl : getPathPrefix(url, config.isWebView);
        dispatch(routeTo(dispatchUrl));
    },
});
